import { ReponseUserResolveError } from "@jack-sparrow-libraries/emotion-models";

export interface AppelInsiParams {
	patientId?: number;
	situationId: number;
	typeOs: string;
	assertionPs: any;
	assertionVitale?: any;
	patientInsiInfo?: Partial<PatientInsiInfo>;
}

export interface PatientInsiInfo {
	patientId?: number;
	nomPatient: string;
	prenomPatient: string;
	sexe: boolean;
	dateNaissance: string;
	ddn?: Date;
	lieuNaissance?: number;
	nirAssure?: string;
	nirBeneficiaire?: string;
}

export interface ReponseInsi {
	date: Date;
	cr: any;
	diagnostic: any;
	insActif: IdentiteInsi;
	historiqueIns: any[];
	traitsDIdentite: any;
}

export interface IdentiteInsi {
	dateDebut: any;
	dateFin: any;
	oid: string;
	ins: string;
	cle: string;
}

export interface ReponseInsiParsed {
	returnAction: ReponseInsiAction;
	returnMessage?: any;
	diagnostic?: any;
	typeErreur?: TypeErreurInsi;
}

export interface ReponseDataInsi {
	err: ReponseUserResolveError;
	typeErreur: TypeErreurInsi;
}

export enum ReponseInsiAction {
	ERROR = 0,
	PARAMS_MISSING = 1,
	SUCCESS = 3,
	ERROR_FONC = 5,
	SERVICE_SUIVANT_IDB = 6,
}

export enum TypeErreurInsi {
	Fonctionnelle = 0,
	Technique = 1,
	TechniqueNonBloquant = 2,
	Abandon = 3,
	TechniqueNonBloquantSilencieux = 4,
	Aucune = 5,
}

export enum EnsiCREnum {
	UNE_IDENTITE_TROUVEE = "UNE_IDENTITE_TROUVEE",
	PLUSIEURS_IDENTITES_TROUVEES = "PLUSIEURS_IDENTITES_TROUVEES",
}
